import React, { ReactElement } from 'react';
import { PanelGrid } from '../../../../../PanelGrid';
import { buildPanelGridApexDemoData } from '../../buildPanelGridConfigs/buildPanelGridApexDemoData/buildPanelGridApexDemoData';

export type ApexSessionInformationPanelGridProps = {
  sessionInformation: SessionInformation;
  isApexDemo: boolean;
};

export function ApexSessionInformationPanelGrid({
  sessionInformation,
  isApexDemo,
}: ApexSessionInformationPanelGridProps): ReactElement {
  if (!isApexDemo) return <></>;

  return (
    <PanelGrid
      data={buildPanelGridApexDemoData(sessionInformation)}
      wideCol="value"
      nameBold={true}
    />
  );
}
